module.exports = __webpack_public_path__ + "img/no_cart.ad0a913b.png";